interface CTAProps {
  onOpenForm: () => void;
}

export default function CTA({ onOpenForm }: CTAProps) {
  return (
    <section id="contact" className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-10">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            準備好開始了嗎？
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
            讓我們幫您快速建立品牌入口，開始接觸您的客戶
          </p>
          <div className="w-20 h-1 bg-teal-500 mx-auto mt-6"></div>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a
            href="/consultation"
            className="inline-flex items-center justify-center px-10 py-5 bg-teal-500 text-white text-lg font-semibold rounded-lg hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-chat-smile-3-line mr-3 text-xl"></i>
            進一步諮詢與了解
          </a>
          <a
            href="/annual-plan"
            className="inline-flex items-center justify-center px-10 py-5 bg-gray-900 text-white text-lg font-semibold rounded-lg hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-file-list-3-line mr-3 text-xl"></i>
            了解年度管理方案
          </a>
        </div>

        <div className="mt-12 bg-gradient-to-r from-gray-50 to-white rounded-xl p-8 border border-gray-100">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <div className="flex items-center">
              <i className="ri-phone-line text-2xl text-teal-600 mr-3"></i>
              <span className="text-gray-700">立即諮詢</span>
            </div>
            <div className="flex items-center">
              <i className="ri-time-line text-2xl text-teal-600 mr-3"></i>
              <span className="text-gray-700">快速回覆</span>
            </div>
            <div className="flex items-center">
              <i className="ri-shield-check-line text-2xl text-teal-600 mr-3"></i>
              <span className="text-gray-700">專業服務</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
